<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">交易单管理</el-breadcrumb-item>
                <el-breadcrumb-item>创建交易单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-form :model="tradeVoucher" :rules="tradeVoucherRules" ref="tradeVoucher" class="demo-ruleForm">
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">关联合同</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="contractTitle">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="tradeVoucher.contractTitle"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="contractSelect"></i>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">交易类型</label>
                    </div>
                    <div class="form-value">
                        <el-select v-model="tradeVoucher.type" disabled placeholder="请选择">
                            <el-option v-for="tradeType in tradeTypeList" :key="tradeType.value" :label="tradeType.label" :value="tradeType.value"></el-option>
                        </el-select>
                    </div>
                </div>

            </div>
            <div class="content-caption dashed">
                <span>买家</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">买家名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{tradeVoucher.buyerName}}</span>
                    </div>
                </div>
            </div>

            <div class="content-caption dashed">
                <span>卖家</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label>卖家名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{tradeVoucher.sellerName}}</span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span class="type required">支付信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">付款时机</label>
                    </div>
                    <div class="form-value">
                        <ul class="enum-list">
                            <li class="enum-item" v-for="(merchantPayTiming, index) in merchantPayTimingList" v-bind:class="{checked:tradeVoucher.payTiming == merchantPayTiming.value}" @click="selectPayTiming(merchantPayTiming, index);">
                                {{merchantPayTiming.name}}
                                <i></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">支付方式</label>
                    </div>
                    <div class="form-value">
                        <ul class="enum-list">
                            <li class="enum-item" v-if="contract != null && contract.id != null" v-bind:class="{checked:true}">
                                {{tradeVoucher.payWayText}}
                                <i></i>
                            </li>
                            <li class="enum-item" v-else v-for="(payWay, index) in payWayList" v-bind:class="{checked:tradeVoucher.payWay == payWay.value}" @click="selectPayWay(payWay, index);">
                                {{payWay.name}}
                                <i></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">交易总金额</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="totalZxAmount">
                            <el-input class="width-1-5x bottom-line" disabled v-model="tradeVoucher.totalZxAmount"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>索要发票</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="">是否索要发票</label>
                    </div>
                    <div class="form-value">
                        <el-radio-group :disabled="contract != null && contract.id != null" v-model="tradeVoucher.invoiceClaimed">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                </div>
            </div>
            <div class="simple-form" v-if="tradeVoucher.invoiceClaimed">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="">收货时段</label>
                    </div>
                    <div class="form-value">
                        <ul class="enum-list">
                            <li class="enum-item" v-for="(recvFrame, index) in recvFrameList" v-bind:class="{checked:tradeVoucher.recvFrame == recvFrame.value}" @click="selectRecvFrame(recvFrame, index);">
                                {{recvFrame.text}}
                                    <i></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="">发票类型</label>
                    </div>
                    <div class="form-value">
                        <ul class="enum-list">
                            <li class="enum-item" v-for="(merchantInvoiceType, index) in merchantInvoiceTypeList" v-bind:class="{checked:tradeVoucher.invoiceType == merchantInvoiceType.value}" @click="selectInvoiceType(merchantInvoiceType, index);">
                                {{merchantInvoiceType.name}}
                                    <i></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="">发票主体类型</label>
                    </div>
                    <div class="form-value">
                        <ul class="enum-list">
                            <li class="enum-item" v-for="(merchantInvoiceSubjectType, index) in merchantInvoiceSubjectTypeList" v-bind:class="{checked:tradeVoucher.invoiceSubjectType == merchantInvoiceSubjectType.value}" @click="selectInvoiceSubjectType(merchantInvoiceSubjectType, index);">
                                {{merchantInvoiceSubjectType.text}}
                                    <i></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="">发票内容标签</label>
                    </div>
                    <div class="form-value">
                        <ul class="enum-list">
                            <li class="enum-item" v-for="(merchantInvoiceCtntTag, index) in merchantInvoiceCtntTagList" v-bind:class="{checked:tradeVoucher.invoiceContentTag == merchantInvoiceCtntTag.name}" @click="selectIvoiceContentTag(merchantInvoiceCtntTag, index);">
                                {{merchantInvoiceCtntTag.name}}
                                    <i></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="">发票抬头</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-1-5x bottom-line" v-model="tradeVoucher.invoiceTitle"></el-input>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="">纳税人识别号</label>
                    </div>
                    <div class="form-value">
                        <el-input class="width-1-5x bottom-line" v-model="tradeVoucher.taxPayerNo"></el-input>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import { openContractListForSelectDlg } from '../contract/dialog'
    //
    import userApi from '../../api/user'
    import tradeApi from '../../api/trade'
    import contractApi from '../../api/contract'
    import merchtFinacApi from '../../api/merchtFinac'
    import servcDelivApi from '../../api/servcDeliv'

    import SwbTradeVoucherList from './TradeVoucherList';
    Routes.add(SwbTradeVoucherList);

    export default {
        name: 'swb-trade-voucher-add',
        path: '/trade/voucher/add',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '交易单创建（手工-仅纯工单生成交易单使用）',
        notAsResc: true,
        authen: false,
        props: {
            workVoucherIdList: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            proofIdList: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            servicerId: {
                type: Number,
                default: null
            },
            servicerName: {
                type: String,
                default: null
            },
            amount: {
                type: Number,
                default: 0.00
            },
            servcType: {
                type: Number,
                default: null
            },
            propFlag: {
                type: Boolean,
                default: false
            },
        },
        data: function () {
            let validateTotalZxAmount = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入总金额'));
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error('必须是金额'));
                    } else {
                        callback();
                    }
                }
            };
            let validateNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    callback();
                }
            };
            return {
                tradeVoucher: {
                    buyerName: null,
                    type: getEnumInfoWith('tradeType', 'name', 'Servc').value,
                    invoiceClaimed: false,
                    invoiceSubjectType: null,
                    invoiceType: null,
                    invoiceContentTag: null,
                    recvFrame: null,
                    payWay: null,
                    payTiming: null,
                    invoiceTitle: null,
                    taxPayerNo: null
                },
                tradeTypeList: [],
                contract: {},
                disabled: false,
                loading: false,
                merchantInvoiceTypeList: [], // 发票类型集合
                merchantInvoiceSubjectTypeList: [], // 发票主体类型集合
                merchantInvoiceCtntTagList: [], // 发票内容标签
                merchantPayTimingList: [], // 付款时机
                payWayList: [], // 支付方式
                recvFrameList: [], // 收货时段
                merchantInvoiceSubjectList: [],
                value: '',
                // 校验
                tradeVoucherRules: {
                    totalZxAmount: [{validator: validateTotalZxAmount, trigger: 'blur'}],
                    contractTitle: [{validator: validateNull, trigger: 'blur'}],
                },
                //
                merchantId: null,
                comId: null,
                comLevel: null,
                workVoucherIds: [],
                servicerIdX: null,
                contractIds: [],
                servcTypeX: null
            }
        },
        created: function () {
            this.getMerchantInvoiceSubjectList();   // 发票抬头
            //
            if(Utils.isFalse(this.propFlag)) {
                this.workVoucherIds = this.$route.query.workVoucherIdList || null;
                this.servicerIdX = this.$route.query.servicerId || null;
                this.tradeVoucher.sellerId = this.$route.query.servicerId || null;
                this.tradeVoucher.sellerName = this.$route.query.servicerName || null;
                this.tradeVoucher.totalZxAmount = this.$route.query.amount || 0.00;
                this.servcTypeX = this.$route.query.servcType || 0;
            } else {
                this.workVoucherIds = this.workVoucherIdList || null;
                this.servicerIdX = this.servicerId || null;
                this.tradeVoucher.sellerId = this.servicerId || null;
                this.tradeVoucher.sellerName = this.servicerName || null;
                this.tradeVoucher.totalZxAmount = this.amount || 0.00;
                this.servcTypeX = this.servcType || 0;
            }
            //
            this.getTradeTypes();
            this.getCurrentUserInfo();
            this.getMerchantInvoiceTypeList();
            this.getMerchantInvoiceSubjectTypeList();
            this.getMerchantInvoiceCtntTagList();
            this.getMerchantPayTimingInfoList();
            this.getMerchantPayWayInfoList();
            this.getRecvFrame();
        },
        methods: {
            getCurrentUserInfo: function () {
                let self = this;
                let postData = {};
                userApi.getUserInfoByContext(postData, function (result) {
                    if(result.type === "info") {
                        let currentInfo = result.data;
                        let scopeEntity = currentInfo.scopeEntity;
                        self.merchantId = scopeEntity.id;
                        self.comId = scopeEntity.comId;
                        self.comLevel = scopeEntity.comLevel;
                        let tradeVoucher = self.tradeVoucher;
                        tradeVoucher.buyerName = scopeEntity.name;
                        tradeVoucher.buyerContactName = scopeEntity.comContactName;
                        tradeVoucher.buyerContactTel = scopeEntity.comContactTel;
                        self.tradeVoucher = Utils.merge({}, tradeVoucher);
                        if(scopeEntity.comLevel != 1) {
                            self.getContractIdsByCurrentMerchtInfo();
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取当前机构可选择的合同ids
            getContractIdsByCurrentMerchtInfo: function () {
                let self = this;
                let postData = {
                    retailerId: self.merchantId,
                    shopId: self.comId
                };
                contractApi.getContractAppliedShopContractIdList(postData, function (result) {
                    if(result.type === "info") {
                        self.contractIds = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取付款时机
            getMerchantPayTimingInfoList: function () {
                let self = this;
                let postData = {
                    merchantId: self.servicerIdX,
                    merchantType: 4
                };
                merchtFinacApi.getMerchantPayTimingListAvailable(postData, function (result) {
                    if(result.type == "info") {
                        //
                        let merchantPayTimingList = result.data;
                        for(let i = 0; i < merchantPayTimingList.length; i++) {
                            let merchantPayTiming = merchantPayTimingList[i];
                            if(merchantPayTiming.name.indexOf("后付款") > -1) {
                                self.tradeVoucher.payTiming = merchantPayTiming.value;
                                self.merchantPayTimingList.add(merchantPayTiming);
                            }
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取支付方式
            getMerchantPayWayInfoList: function () {
                let self = this;
                let postData = {
                    servicerId: this.servicerIdX
                };
                merchtFinacApi.getEnabledMerchantPayWayList(postData, function (result) {
                    if(result.type == "info") {
                        //
                        self.payWayList = result.data;
                        let payWayList = self.payWayList;
                        for(let i = 0; i < payWayList.length; i++) {
                            let payWay = payWayList[i];
                            if(payWay.defaulted) {
                                self.tradeVoucher.payWay = payWay.value;
                            }
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取收货时段
            getRecvFrame: function () {
                this.recvFrameList = getEnumList('recvFrame');
                let recvFrame = getEnumInfoWith('recvFrame', 'name', 'NoLimit');
                this.tradeVoucher.recvFrame = recvFrame.value;
            },
            // 获取发票类型
            getMerchantInvoiceTypeList: function () {
                let self = this;
                let postData = {
                    merchantId: this.servicerIdX,
                    merchantType: 4    // 服务商
                };
                merchtFinacApi.getMerchantInvoiceTypeListAvailable(postData, function (result) {
                    if(result.type == "info") {
                        //
                        self.merchantInvoiceTypeList = result.data;
                        let merchantInvoiceTypeList = self.merchantInvoiceTypeList;
                        for(let i = 0; i < merchantInvoiceTypeList.length; i++) {
                            let merchantInvoiceType = merchantInvoiceTypeList[i];
                            if(merchantInvoiceType.defaulted) {
                                // self.tradeVoucher.invoiceType = merchantInvoiceType.value;
                                self.makeTradeVoucherInvoiceInfo(merchantInvoiceType.value);
                            }
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取发票主体类型
            getMerchantInvoiceSubjectTypeList: function () {
                let self = this;
                let invoiceSubjectType = getEnumInfoWith('invoiceSubjectType', 'name', 'Company');
                self.merchantInvoiceSubjectTypeList.push(invoiceSubjectType);
                self.tradeVoucher.invoiceSubjectType = invoiceSubjectType.value;
            },
            // 获取发票内容标签
            getMerchantInvoiceCtntTagList: function () {
                let self = this;
                let postData = {
                    merchantId: this.servicerIdX,
                    merchantType: 4    // 服务商
                };
                merchtFinacApi.getMerchantInvoiceCtntTagList(postData, function (result) {
                    if(result.type == "info") {
                        //
                        self.merchantInvoiceCtntTagList = result.data;
                        let merchantInvoiceCtntTagList = self.merchantInvoiceCtntTagList;
                        for(let i = 0; i < merchantInvoiceCtntTagList.length; i++) {
                            let merchantInvoiceCtntTag = merchantInvoiceCtntTagList[i];
                            if(merchantInvoiceCtntTag.defaulted) {
                                self.tradeVoucher.invoiceContentTag = merchantInvoiceCtntTag.name;
                            }
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 交易类型
            getTradeTypes: function () {
                let tradeTypeList = getEnumInfoWith('tradeType', 'name', ['Servc', 'Integ']);
                for(let i = 0; i < tradeTypeList.length; i++) {
                    let tradeType = tradeTypeList[i];
                    this.tradeTypeList.add({value: tradeType.value, label: tradeType.text});
                }
            },
            // 发票主体信息
            getMerchantInvoiceSubjectList: function () {
                let self = this;
                let postData = {};
                //
                let msgBoxDlg = MsgBox.loading();
                merchtFinacApi.getMerchantInvoiceSubjectList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        self.merchantInvoiceSubjectList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //选择合同
            contractSelect: function () {
                let self = this;
                if(self.comLevel != 1 && self.contractIds.length == 0) {
                    MsgBox.warning("当前机构没有适用的合同，如果需要请向总部申请！");
                    return;
                }
                //
                let contractTypeList = [];
                let contractServcPurchType = getEnumInfoWith('contractType', 'name', 'ServcPurch');
                let contractIntegPurchType = getEnumInfoWith('contractType', 'name', 'IntegPurch');
                contractTypeList.push(contractServcPurchType.value);
                contractTypeList.push(contractIntegPurchType.value);
                //
                let filterItems = {
                    curValid: true,
                    confirmed: true,
                    fullfilled: false,
                    closed: false,
                    terminated: false,
                    offline: false,
                    lockModes: [0, -1],
                    typeIds: contractTypeList,
                    sndPartyId: self.servicerIdX,
                    sndPartyType: getEnumInfoWith('merchantType', 'name', 'Servicer').value,
                    contractIds: self.comLevel != 1 ? self.contractIds : [],
                    servcType: self.servcTypeX
                };
                openContractListForSelectDlg(filterItems, function (contract) {
                    if(!Utils.isNoB(contract)) {
                        self.contract = contract;
                        //合同类型
                        let typeId = contract.typeId;
                        let contractTypeInfo = getEnumInfoWith('contractType', 'value', typeId);
                        let tradeType = contractTypeInfo.tradeType;
                        if(tradeType == 1) {
                            MsgBox.warning("请选择服务采购合同或者集成采购合同");
                            self.disabled = true;
                        } else {
                            let data = {};
                            data.contractNo = contract.no;
                            tradeApi.getTradeVoucherByContractNo(data, function (result) {
                                //
                                let tradeVoucher = result.data || null;
                                if(tradeVoucher == null) {
                                    tradeVoucher = self.tradeVoucher;
                                    //
                                    let tradeTypeInfo = getEnumInfoWith('tradeType', 'value', tradeType);
                                    if(tradeTypeInfo != null) {
                                        tradeVoucher.type = tradeTypeInfo.value;
                                    }
                                    tradeVoucher.contractTitle = contract.title;
                                    let merchantType = getEnumInfoWith('merchantType', 'value', contract.fstPartyType);
                                    if(merchantType != null) {
                                        tradeVoucher.buyerTypeText = merchantType.text;
                                    }
                                    tradeVoucher.invoiceType = contract.invoiceType;
                                    tradeVoucher.invoiceContentTag = contract.invoiceContentTag;
                                    tradeVoucher.invoiceTitle = contract.invoiceTitle;
                                    tradeVoucher.taxPayerNo = contract.taxPayerNo;
                                    tradeVoucher.payWay = contract.payWay;
                                } else {
                                    tradeVoucher.totalZxAmount = self.tradeVoucher.totalZxAmount;
                                }
                                //
                                tradeVoucher.payTiming = self.tradeVoucher.payTiming;
                                tradeVoucher.payWayText = getEnumInfoWith('payWay', 'value', tradeVoucher.payWay).text;
                                tradeVoucher.invoiceClaimed = false;
                                //
                                self.tradeVoucher = Utils.merge({}, tradeVoucher);
                            });
                        }
                    }
                });
            },
            // 选择付款时机
            selectPayTiming: function (item, index) {
                let self = this;
                let merchantPayTimingList = self.merchantPayTimingList;
                for(let i = 0; i < merchantPayTimingList.length; i++) {
                    if(i == index) {
                        self.tradeVoucher.payTiming = item.value;
                        self.tradeVoucher = Utils.merge({}, self.tradeVoucher);
                    }
                }
            },
            // 选择支付方式
            selectPayWay: function (item, index) {
                let self = this;
                let payWayList = self.payWayList;
                for(let i = 0; i < payWayList.length; i++) {
                    if(i == index) {
                        self.tradeVoucher.payWay = item.value;
                        self.tradeVoucher = Utils.merge({}, self.tradeVoucher);
                    }
                }
            },
            // 选择收货时段
            selectRecvFrame: function (item, index) {
                let self = this;
                let recvFrameList = self.recvFrameList;
                for(let i = 0; i < recvFrameList.length; i++) {
                    if(i == index) {
                        self.tradeVoucher.recvFrame = item.value;
                        self.tradeVoucher = Utils.merge({}, self.tradeVoucher);
                    }
                }
            },
            // 选择发票主体类型
            selectInvoiceSubjectType: function (item, index) {
                let self = this;
                let merchantInvoiceSubjectTypeList = self.merchantInvoiceSubjectTypeList;
                for(let i = 0; i < merchantInvoiceSubjectTypeList.length; i++) {
                    if(i == index) {
                        self.tradeVoucher.invoiceSubjectType = item.value;
                        self.tradeVoucher = Utils.merge({}, self.tradeVoucher);
                    }
                }
            },
            // 选择发票类型
            selectInvoiceType: function (item, index) {
                let self = this;
                let merchantInvoiceTypeList = self.merchantInvoiceTypeList;
                for(let i = 0; i < merchantInvoiceTypeList.length; i++) {
                    if(i == index) {
                        //
                        self.makeTradeVoucherInvoiceInfo(item.value);
                    }
                }
            },
            makeTradeVoucherInvoiceInfo(invoiceType){
                let self = this;
                let tradeVoucher = self.tradeVoucher;
                tradeVoucher.invoiceType = invoiceType;
                let merchantInvoiceSubjectList = self.merchantInvoiceSubjectList;
                if(!Utils.isNoB(merchantInvoiceSubjectList) && merchantInvoiceSubjectList.length > 0) {
                    for(let j = 0; j < merchantInvoiceSubjectList.length; j++) {
                        let subjectInfo = merchantInvoiceSubjectList[j];
                        if(subjectInfo.invoiceType == invoiceType) {
                            tradeVoucher.invoiceTitle = subjectInfo.invoiceTitle;
                            tradeVoucher.taxPayerNo = subjectInfo.taxPayerNo;
                        }
                    }
                }
                self.tradeVoucher = Utils.merge({}, self.tradeVoucher);
            },
            // 选择发票内容标签
            selectIvoiceContentTag: function (item, index) {
                let self = this;
                let merchantInvoiceCtntTagList = self.merchantInvoiceCtntTagList;
                for(let i = 0; i < merchantInvoiceCtntTagList.length; i++) {
                    if(i == index) {
                        self.tradeVoucher.invoiceContentTag = item.name;
                        self.tradeVoucher = Utils.merge({}, self.tradeVoucher);
                    }
                }
            },
            // 返回结果
            getDlgResult: function () {
                let self = this;
                let result = {};
                if(Utils.isNoB(self.tradeVoucher.payTiming)) {
                    result.type = 'warn';
                    result.message = '请选择付款时机！';
                } else if(Utils.isNoB(self.tradeVoucher.payWay)) {
                    result.type = 'warn';
                    result.message = '请选择支付方式！';
                } else {
                    this.$refs['tradeVoucher'].validate(function (valid) {
                        if(valid) {
                            if(!self.tradeVoucher.invoiceClaimed) {
                                self.tradeVoucher.invoiceSubjectType = null;
                                self.tradeVoucher.invoiceType = null;
                                self.tradeVoucher.invoiceContentTag = null;
                                self.tradeVoucher.recvFrame = null;
                                self.tradeVoucher.invoiceTitle = null;
                                self.tradeVoucher.taxPayerNo = null;
                            }
                            //
                            let contract = self.contract;
                            if(!Utils.isNoB(contract) && contract.id != null) {
                                self.tradeVoucher.contractId = self.contract.id;
                                self.tradeVoucher.contractNo = self.contract.no;
                            }
                            self.tradeVoucher.servicerId = self.servicerIdX;
                            self.tradeVoucher.workVoucherIdList = self.workVoucherIds;
                            self.tradeVoucher.proofIdList = self.proofIdList;
                            //
                            result.type = 'info';
                            result.data = self.tradeVoucher;
                        } else {
                            result.type = 'warn';
                            result.message = '校验失败';
                        }
                    });
                }
                return result;
            },
            showTradeVoucherList: function (no) {
                let tradeVoucherType = getEnumInfoWith('tradeVoucherType', 'name', 'GeneralVoucher').value;
                if(!Utils.isNoB(this.contract) && this.contract.id != null) {
                    tradeVoucherType = getEnumInfoWith('tradeVoucherType', 'name', 'ContractVoucher').value;
                }
                this.$router.push({
                    path: SwbTradeVoucherList.path,
                    query: {no: no, tradeVoucherType: tradeVoucherType}
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/tradeVoucher/TradeVoucherAdd.vue